import React, { lazy, useRef } from 'react';
import IntersectionObserverFunc from './IntersectionObserverFunc.js';
export const Item = (props) => {
  const { host, item, id, openModal } = props;

  const itemDetails = {
    id: id,
    categories: item.categories,
    date: item.date,
    heading: item.heading,
    imageUrl: item.imageUrl,
    text: item.text,
    thumbnailUrl: item.thumbnailUrl,
    type: item.type,
    url: item.url,
    videoUrl: item.videoUrl,
  };

  // const itemRef = useRef(null);
  // const handleObserver = (entries) => {
  //   const target = entries[0];
  //   if (target.isIntersecting) {
  //     target.target.classList.add('show');
  //   } else {
  //     target.target.classList.remove('show');
  //   }
  // };

  // IntersectionObserverFunc(itemRef, handleObserver);

  return (
    <article
      id={itemDetails.id}
      onClick={openModal}
      className='item'
      data-heading={itemDetails.heading}
      data-imageurl={`${host}${itemDetails.imageUrl}`}
      data-text={itemDetails.text}
      data-type={itemDetails.type}
      data-thumbnail={itemDetails.thumbnailUrl}
      data-videourl={itemDetails.videoUrl}
      data-url={itemDetails.url}
      // ref={itemRef}
    >
      <div className='item-inner-container'>
        <img
          className='item-thumbnail'
          loading='lazy'
          src={`${host}${itemDetails.thumbnailUrl}`}
          alt={itemDetails.heading}
        />
        <img
          loading='lazy'
          className='video-watermark'
          src='/img/button_play_w.svg'
          alt='video play water mark'
          style={{ display: itemDetails.type === 'video' ? 'block' : 'none' }}
        ></img>
        <p className='item-heading'>{itemDetails.heading}</p>
      </div>
    </article>
  );
};

export default Item;
